export default "__VITE_ASSET__V$7vf_kY__";